import { useState, useRef } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Input from './Input';
import Textarea from './Textarea';
import Button from './Button';
import { siteConfig } from '../../data/config';

const { contact, services: SERVICES, whatsappGreeting } = siteConfig;

export default function ContactForm({ className = '' }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const [errors, setErrors] = useState({});
  const formRef = useRef(null);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email required';
    if (!form.phone.trim() || !/^\+?[\d\s-]{10,}$/.test(form.phone)) e.phone = 'Valid phone required';
    if (!form.message.trim()) e.message = 'Message is required';
    return e;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: '' });
  };

  // On submit → open WhatsApp with form data pre-filled
  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    const msg =
      whatsappGreeting +
      `Name: ${form.name}\n` +
      `Email: ${form.email}\n` +
      `Phone: ${form.phone}\n` +
      `Service: ${form.service || 'General Enquiry'}\n\n` +
      `Message: ${form.message}`;

    window.open(
      `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(msg)}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit} className={`space-y-4 ${className}`} noValidate>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input id="name" name="name" label="Full Name *" placeholder="Your full name" value={form.name} onChange={handleChange} error={errors.name} autoComplete="name" />
        <Input id="email" name="email" type="email" label="Email Address *" placeholder="you@example.com" value={form.email} onChange={handleChange} error={errors.email} autoComplete="email" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input id="phone" name="phone" type="tel" label="Phone Number *" placeholder="+91 97184 31522" value={form.phone} onChange={handleChange} error={errors.phone} autoComplete="tel" />
        <div className="flex flex-col gap-1">
          <label htmlFor="service" className="text-base font-medium" style={{ color: 'var(--color-text)' }}>Service Required</label>
          <select
            id="service"
            name="service"
            value={form.service}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-[var(--color-border)] text-base focus:outline-none focus:ring-2 focus:ring-[var(--color-secondary)] bg-white"
            style={{ color: 'var(--color-text)' }}
          >
            <option value="">Select a service</option>
            {SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>
      <Textarea id="message" name="message" label="Your Message *" placeholder="Describe your requirement..." value={form.message} onChange={handleChange} error={errors.message} rows={4} />
      <div className="pt-2">
        <Button type="submit" variant="primary" className="w-full">
          <FaWhatsapp className="text-lg" /> Send via WhatsApp
        </Button>
      </div>
    </form>
  );
}
